module.exports = "/_next/static/images/property-mobile@2x-5850b648a39c4fafb3591f92e1d7a982.png";